<template>
  <container v-if="countries" :class="['flags']">
    <card>
      <card-text :class="['py-4']">
        <flex :spacing="3">
          <flex-col sm8 xs12 equal-height v-for="(flag, index) in countries.countries" :span="4" :key="index" :class="['text-center']">
            <flag @click="log('click', 'flag', flag)" :flat="flat" :title="`${flag.name} (${flag.code})`" :flags-dir="flagsDir" :rounded="rounded" :ratio="ratio" :size="size" :class="['cursor-pointer']" :code="flag.code" />
            <p v-html="`${flag.name} (${flag.code.toLowerCase()})`" :class="['my-3', 'text-sm']" />
          </flex-col>
        </flex>
      </card-text>
    </card>
  </container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageColors',
  mixins: [
    methods
  ],
  data () {
    return {
      countries: null
    }
  },
  props: {
    ratio: {
      type: String,
      default: '1:1'
    },
    flat: {
      type: Boolean
    },
    flagsDir: {
      type: String,
      required: true
    },
    rounded: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 3
    },
    elevation: {
      type: String,
      default: 'md'
    }
  },
  mounted () {
    this.getExternalData('flags.json', 'countries')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/flags.vue